// extracted by mini-css-extract-plugin
export default {"image-link":"xqNssz","imageLink":"xqNssz","image":"KPvS5C","role-icon":"I2JySS","roleIcon":"I2JySS","action":"fykSxb","wired":"qAlCAU","name":"iVCrVJ","skeleton":"WJN0pu"};